import {
  Card,
  Box,
  Skeleton
} from '@mui/material';

const SkeletonReference = () => {
  return (
    <Card
      sx={{
        borderRadius: 3,
        boxShadow: 3,
        bgcolor: "background.paper",
        p: 0.75,
        overflow: "visible",
        position: "relative",
      }}
    >
      <Box
        sx={{
          position: "relative",
          borderRadius: 2,
          overflow: "hidden",
          height: 280,
          bgcolor: "grey.100",
        }}
      >
        {/* Image skeleton */}
        <Skeleton variant="rectangular" height="100%" />

        {/* Bottom info bar skeleton */}
        <Box
          sx={{
            position: "absolute",
            left: 0,
            right: 0,
            bottom: 0,
            px: 1.25,
            py: 1,
            bgcolor: "#000000CC",
          }}
        >
          <Skeleton variant="text" width="80%" height={24} />
          <Skeleton variant="text" width="60%" height={16} sx={{ mt: 0.5 }} />
        </Box>
      </Box>
    </Card>
  );
};

export default SkeletonReference;
